//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener } from '@angular/core';
import { NgModule } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { func, bool } from 'prop-types';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ApiResult } from '@soco/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SocoModalService } from '@soco/modal';
import { DatePipe } from '@angular/common';
import { RescheduleService } from './reschedule.service';
import { DBTraceLogService } from '../shared/services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../shared/services/coolEmail/coolEmail.service';
import { AppCommonService } from '../shared/services/common/app-common.service';
import {
    OrderAttributes, AmendOrder
} from './reschedule-entities';
import { DBTraceLog, LogType } from '../shared/services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../shared/services/common/app-common-entities';
import { SocoHttpService } from '@soco/http';
import { MatStepper } from '@angular/material/stepper';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AvailabilityInput, AvailabilityOutput } from '../shared/components/availability/availability-selection-entities';
import { AppointmentConfirmationInput, AppointmentConfirmationOutput } from '../shared/components/appointmentconfirmation/appointment-confirmation-entities';
import { AppBaseComponent } from '../shared/components/base/app-base.component';
import { BnNgIdleService } from 'bn-ng-idle';

@Component({
    templateUrl: 'reschedule.component.html',
    styleUrls: ['reschedule.component.css', 'reschedule.component.scss'],
    providers: [DatePipe, RescheduleService, DBTraceLogService, CoolEmailService, AppCommonService]
})
export class RescheduleComponent extends AppBaseComponent implements OnInit {

    @ViewChild(MatStepper, { static: false }) reschedulingStepper: MatStepper;
    //@ViewChild(AvailabilityComponent, { static: false }) availabilityCopm: AvailabilityComponent;

    //#region Variables
    public ldc: string = '';
    public ldcFullName: string;
    public seedDate: string;
    public orderNumber: string = '';
    public premiseNumber: string = '';
    public marketerName: string = '';
    public availabilityResponse: any;
    public urlCode: string;
    public sentinelAvailableDays = [];
    public timeSlots = [];
    public filteredTimeSlots = [];
    public selectedTimeSlot: string = '';
    public selectdScheduleDate: string;
    public selectedScheduleWindow: string = '';
    public selectedTimeSlotWindow: string = '';
    public ccbAppointmentStart: string;
    public ccbAppointmentEnd: string;
    public data: any;
    public isPageLoadReady: boolean = false;
    public showSpinner: boolean = true;
    public showError: boolean = false;
    public errorInfo: any;
    public showTimeSlotLoadingSpinner: boolean = false;
    public showConfirmSpinner: boolean = false;

    questionsForm: FormGroup;
    scheduleForm: FormGroup;
    confirmForm: FormGroup;
    successForm: FormGroup;
    isLinear = false;

    public orderAttributesAPIResult: any;
    public rescheduleEligibilityAPIResult: any;
    public orderAttributes: OrderAttributes;
    public amendOrder: AmendOrder;
    public errorMessageContactPhoneNo: string = '';
    public announcementTitle: string = '';
    public announcementDescription: string = '';
    public firstSentinelAvailableDate: string = '';
    public maxAvailableDatesAllowed: number = 0;
    public orderType: string = '';
    public personID: string = '';
    public eligibilityReturnMessage: string = '';
    public matchOrderEffectiveDate: string = '';
    public showTimeSlots: boolean = true;
    public appConfigurationDataList: Array<AppConfigurationData> = [];
    public entranceInstructionsList = [];
    public covidVideo: string = '';
    public contactPhoneNo: string = '';
    public contactHours: string = '';
    public showInitialSpinner: boolean = false;
    public showLogOut: boolean = false;
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';
    public entranceCode: string = '';
    public entranceCodeReminderMsg: string = '';
    public availabilityInput: AvailabilityInput;
    public availabilityOutput: AvailabilityOutput;
    
    public appointmentConfirmationInput: AppointmentConfirmationInput;
    public emailToList: string;
    public sessionTimeoutWarningMsg: string = '';
    public sessionExpired: boolean = true;
    public timeOutPeriod: number = 3000;
    public timeOutWarning: number = 30;
    public userActivity: any;
    public interval: any;

    //#endregion

    constructor(public rescheduleService: RescheduleService, private route: ActivatedRoute, private formBuilder: FormBuilder,
        public datepipe: DatePipe, public http: SocoHttpService, public dbTraceLogService: DBTraceLogService,
        public deviceService: DeviceDetectorService, public coolEmailService: CoolEmailService,
        private appCommonService: AppCommonService, private bnIdle: BnNgIdleService) {

        //Parent component instantiation
        super(http, dbTraceLogService, coolEmailService, deviceService);

        try {
            //this.urlCode = this.route.snapshot.queryParamMap.get('urlcode');        
            if (this.route.snapshot.url.length > 1)
                this.urlCode = this.route.snapshot.url[1].path;
            //console.log('urlCode : ', this.urlCode);

            this.availabilityInput = new AvailabilityInput();
            this.availabilityOutput = new AvailabilityOutput();
           
            this.appointmentConfirmationInput = new AppointmentConfirmationInput();

            this.logReferenceID = this.datepipe.transform(Date.now(), "MMddyyyyHHmmss");
            this.insertDBTraceLog(LogType.Info, 'Reschedule component initiated successfully');

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading reschedule constructor, Error: ' + e.message.substring(0, 500));
        }
    };

    ngOnInit() {
        try {
            //hide multi step clickable status bar
            $('.mat-horizontal-stepper-header-container').hide();
            //to avoid unnecessary vertical scroll when focusing autofill values in input.
            $(".wrapper").css("overflow-y", "auto");
            //to avoid horizontal scroll, Applying below style on root div
            $(".main-panel").css("overflow-x", "hidden");

            //Initiate stepper forms
            this.questionsForm = this.formBuilder.group({});
            this.scheduleForm = this.formBuilder.group({});
            this.confirmForm = this.formBuilder.group({});
            this.successForm = this.formBuilder.group({});

            //Change hard coded value to config driven in later development
            this.maxAvailableDatesAllowed = 45;

            //$('[data-toggle="popover"]').popover(
            //    //{content : this.announcementDescription}
            //    );

            //Fetch Order Attributes, Check Eligibility & Load Availability synchronously
            this.GetOrderAttributes(this.urlCode);

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading ngOnInit, Error: ' + e.message.substring(0, 500));
        }
    }

    // #region Init Methods

    GetOrderAttributes(UrlCode: string) {
        try {
            this.showInitialSpinner = true;

            this.rescheduleService.getOrderAttributes(UrlCode).subscribe(ApiResult => {

                //console.log('OrderAttributes ApiResult.data ', ApiResult.data);            

                if (ApiResult.data != null) {
                    this.insertDBTraceLog(LogType.Info, 'Order attributes fetched successfully');

                    //capture contact phone no to show in error message
                    if (ApiResult.data.contactPhoneNo != null && ApiResult.data.contactPhoneNo != '') {
                        this.errorMessageContactPhoneNo = this.formatPhoneNumber(ApiResult.data.contactPhoneNo)
                    }

                    if (ApiResult.data.ldc != null && ApiResult.data.ldc != '' &&
                        ApiResult.data.sourceOrderNumber != null && ApiResult.data.sourceOrderNumber != '' &&
                        ApiResult.data.isRescheduleEligible) {
                        //console.log(ApiResult.data);
                        this.ldc = ApiResult.data.ldc;
                        this.orderNumber = ApiResult.data.sourceOrderNumber;
                        this.orderType = ApiResult.data.orderType;
                        this.personID = ApiResult.data.personID;
                        this.entranceCode = ApiResult.data.entranceInstructions;
                        this.entranceCodeReminderMsg = ApiResult.data.entranceCodeReminderMessage;//this.getEntranceCodeReminderMsg('HOME');

                        //As of now GCMA backend services are not depend on premise number
                        if (this.ldc != 'AGLC')
                            this.premiseNumber = ApiResult.data.premisesNumber;
                        else {
                            this.premiseNumber = '';
                            this.marketerName = ApiResult.data.marketerName;
                        }

                        //Get Application Configs
                        this.GetApplicationConfigs();

                        //Check reschedule eligibility                    
                        //this.GetRescheduleEligibilityOnLanding();                    
                    }
                    else {
                        this.insertDBTraceLog(LogType.Info, 'Order attributes fetched, Order is not eligible to reschedule');
                        this.processError();
                    }
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching order attributes, API Result is Null');
                    this.processError();
                }

            }, ApiResult => {
                //capture error
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    if (ApiResult.data != null && ApiResult.data.contactPhoneNo != '')
                        this.errorMessageContactPhoneNo = this.formatPhoneNumber(ApiResult.data.contactPhoneNo);

                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching order attributes');
                    this.processError();
                }
            });
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while fetching order attributes, Error: ' + e.message.substring(0, 500));
        }

    }

    GetApplicationConfigs() {
        try {
            //this.showInitialSpinner = true;

            this.appCommonService.getApplicationConfigs().subscribe(ApiResult => {

                //console.log('ApplicationConfig ApiResult: ', ApiResult.data);            

                if (ApiResult.data != null) {

                    this.insertDBTraceLog(LogType.Info, 'Application configs fetched successfully');

                    ApiResult.data.forEach(configData => {
                        this.appConfigurationDataList.push(configData);
                    });

                    ////Set Entrance Instruction Notes
                    this.entranceInstructionsList = this.appConfigurationDataList.filter(item => item.configurationType == 'Entrance Instruction Notes')
                        .map(cv => cv.configurationValue);

                    this.emailToList = this.appConfigurationDataList.filter(item => (item.configurationKey == 'EmailTo'))
                        .map(cv => cv.configurationValue)[0];

                    this.timeOutPeriod = Number(this.appConfigurationDataList.filter(item => item.configurationKey == 'SessionTimeOut')
                        .map(cv => cv.configurationValue)[0]);

                    this.timeOutWarning = Number(this.appConfigurationDataList.filter(item => item.configurationKey == 'SessionTimeOutWarning')
                        .map(cv => cv.configurationValue)[0]);

                    //set contactPhone on load
                    this.setContactPhoneNoAndHours();
                    this.getLDCFullName();

                    //Trigger timeout watch after configs load
                    this.triggerTimeOut();

                    //Prepate Availability Input after fetching order attributes & app configs
                    this.prepareAvailabilityInput();

                    //this.isPageLoadReady = true;
                    this.showInitialSpinner = false;
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs, API Result is Null');
                    this.processError();
                }

            }, ApiResult => {
                //capture error
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs');
                    this.processError();
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while fetching application configs, Error: ' + e.message.substring(0, 500));
        }
    }

    // #endregion

    // #region Amend Order

    private AmendOrder(fieldInstructions: string, stepper: MatStepper) {
        try {
           
            this.showConfirmSpinner = true;
            var updatedFieldInstructions: string = '';
            if (fieldInstructions != '')
                fieldInstructions = fieldInstructions + '\n';

             updatedFieldInstructions = fieldInstructions;

            this.amendOrder = new AmendOrder();
            this.amendOrder.ldc = this.ldc;
            this.amendOrder.orderNumber = this.orderNumber;
            this.amendOrder.fieldInstructions = updatedFieldInstructions; //fieldInstructions;

            //GCMA specific fields
            this.amendOrder.scheduleDate = this.selectdScheduleDate;
            this.amendOrder.scheduleWindow = this.selectedScheduleWindow;

            //CCB specific fields
            this.amendOrder.premisesNumber = this.premiseNumber;
            this.amendOrder.appointmentStart = this.ccbAppointmentStart;
            this.amendOrder.appointmentEnd = this.ccbAppointmentEnd;
            this.amendOrder.personID = this.personID;

            if (this.ldc === 'AGLC')
                this.insertDBTraceLog(LogType.Info, 'Order rescheduling initiated for Schedule Date:' + this.selectdScheduleDate + ', Schedule Window: ' + this.selectedTimeSlotWindow);
            else
                this.insertDBTraceLog(LogType.Info, 'Order rescheduling initiated for Appt Start:' + this.ccbAppointmentStart + ', Appt End: ' + this.ccbAppointmentEnd);

            //setTimeout(function () { this.showConfirmSpinner = false; stepper.next(); }, 3000);       

            this.rescheduleService.amendOrder(this.amendOrder).subscribe(ApiResult => {

                //console.log('Amend Order API Result: ', ApiResult);
                if (ApiResult != null && ApiResult.statusCode == 200) {

                    if (this.ldc === 'AGLC')
                        this.insertDBTraceLog(LogType.Info, 'Order rescheduled successfully for Schedule Date:' + this.selectdScheduleDate + ', Schedule Window: ' + this.selectedTimeSlotWindow);
                    else
                        this.insertDBTraceLog(LogType.Info, 'Order rescheduled successfully for Appt Start:' + this.ccbAppointmentStart + ', Appt End: ' + this.ccbAppointmentEnd);

                    //Hide Logout in last page 
                    //If displayed and clicked, it will navigate back to initial screen but Reschedule eligibility has to be decided on pageload. 
                    this.showLogOut = false;
                    //Do not force timeout on lastpage to avoid navigating back to initial screen
                    this.sessionExpired = true;

                    //Navigate to next page
                    this.showConfirmSpinner = false;
                    stepper.next();
                }
                else {

                    this.insertDBTraceLog(LogType.Error, 'Error occured while rescheduling order, APIResult is either null or not 200');

                    this.showConfirmSpinner = false;
                    this.processError();
                }

            }, ApiResult => {
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while rescheduling order, Invalid APIResult');

                    this.showConfirmSpinner = false;
                    this.processError();
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while amending order, Error: ' + e.message.substring(0, 500));
        }
    }

    // #endregion    

    // #region Button Clicks   

    navigateToHome() {

        this.reschedulingStepper.selectedIndex = 0;
        this.insertDBTraceLog(LogType.Info, 'Navigated to home screen');
    }

    // #endregion


    // #region Helper Methods

    processError(): void {
        this.showError = true;
        //this.errorInfo = ApiResult.data;
        this.showSpinner = false;
        this.showTimeSlotLoadingSpinner = false;
        this.showConfirmSpinner = false;
        this.showInitialSpinner = false;
        this.showLogOut = false;
        //to hide content container's border
        $('#divRescheduling').hide();

    }

    private processErrorFromChild($event) {
        this.processError();
    }

    private formatPhoneNumber(phoneNumberString: string) {

        if (phoneNumberString.length == 10) {
            //reformat and return phone number
            return phoneNumberString.replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3");
        }
        return phoneNumberString
    }

    public setContactPhoneNoAndHours() {

        if (this.ldc != 'AGLC') {
            this.contactPhoneNo = this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationType == 'Contact Phone Number'))
                .map(cv => cv.configurationValue)[0];

            this.contactHours = this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationType == 'Contact Hours'))
                .map(cv => cv.configurationValue)[0];
        }
        else {
            //Set marketer details
            this.contactPhoneNo = this.errorMessageContactPhoneNo;
            this.contactHours = 'During business hours';
        }

    }

    private getLDCFullName() {
        if (this.ldc === 'NG' || this.ldc === 'IL')
            this.ldcFullName = 'Nicor Gas';
        else if (this.ldc === 'VNG')
            this.ldcFullName = 'Virginia Natural Gas';
        else if (this.ldc === 'CGC')
            this.ldcFullName = 'Chattanooga Gas';
        else if (this.ldc === 'AGLC')
            this.ldcFullName = this.marketerName;
    }

    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = 2; //Reschedule Portal
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.urlCode;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);

    }

    private prepareAvailabilityInput() {

        this.availabilityInput.ldc = this.ldc;
        this.availabilityInput.kmiUrlCode = this.urlCode;
        this.availabilityInput.orderNumber = this.orderNumber;
        this.availabilityInput.orderType = this.orderType;
        this.availabilityInput.premisesNumber = this.premiseNumber;
        this.availabilityInput.logReferenceID = this.logReferenceID;
        this.availabilityInput.portalTypeID = 2; //Reschedule
        this.availabilityInput.entranceCodeReminderMsg = this.entranceCodeReminderMsg;
        this.availabilityInput.emailToList = this.emailToList;
        this.availabilityInput.appointmentType = 'Amend';
        this.availabilityInput.serviceOrderActiontype = 'Amend';
    }

    private recieveAvailabilitySelection($event) {
        this.availabilityOutput = $event;

        this.selectedTimeSlot = this.availabilityOutput.selectedTimeSlot;
        this.selectedTimeSlotWindow = this.availabilityOutput.selectedTimeSlotWindow;
        this.selectdScheduleDate = this.availabilityOutput.selectedScheduleDate;
        this.selectedScheduleWindow = this.availabilityOutput.selectedScheduleWindow;
        this.ccbAppointmentStart = this.availabilityOutput.ccbAppointmentStart;
        this.ccbAppointmentEnd = this.availabilityOutput.ccbAppointmentEnd;

        //prepare appt confirmation input for child control
        this.prepareAppointmentConfirmationInput();
    }

    private prepareAppointmentConfirmationInput() {

        this.appointmentConfirmationInput.selectedTimeSlot = this.selectedTimeSlot;
        this.appointmentConfirmationInput.selectedTimeSlotWindow = this.selectedTimeSlotWindow;
        this.appointmentConfirmationInput.entranceInstructionsList = this.entranceInstructionsList;
        this.appointmentConfirmationInput.specialFeeMsg = ''; //Doesn't apply to reschedule
        this.appointmentConfirmationInput.ldc = this.ldc;
        this.appointmentConfirmationInput.logReferenceID = this.logReferenceID;
        this.appointmentConfirmationInput.portalTypeID = 2; //ReSchedule        
        this.appointmentConfirmationInput.emailToList = this.emailToList;
    }

    //#region Session TimeOut

    private triggerTimeOut() {
        this.bnIdle.startWatching(this.timeOutPeriod - this.timeOutWarning).subscribe((res) => {
            if (res && !this.sessionExpired) {
                //start countdown
                this.startCountdown(this.timeOutWarning);
                //navigate home once countdown finishes
                this.userActivity = setTimeout(this.navigateHome.bind(this), this.timeOutWarning * 1000);
            }
        })
    }

    navigateHome = () => {
        this.navigateToHome();
        this.sessionExpired = true;
        this.sessionTimeoutWarningMsg = '';
    }

    private startCountdown(seconds) {
        let counter = seconds;

        this.interval = setInterval(() => {
            this.sessionTimeoutWarningMsg = 'Session expiring in ' + counter;
            counter--;

            if (counter < 0) {
                clearInterval(this.interval);
                this.sessionTimeoutWarningMsg = '';
            }
        }, 1000);
    }

    //stop countdown on user activity
    @HostListener('document:keydown', ['$event'])
    @HostListener('window:mousemove', ['$event'])
    @HostListener('window:wheel', ['$event'])
    @HostListener('touchstart', ['$event'])
    onEvent(event) {
        if (this.sessionTimeoutWarningMsg != '') {
            clearTimeout(this.userActivity);
            clearInterval(this.interval);
            this.sessionTimeoutWarningMsg = '';
        }
    }

    //#endregion


    // #endregion

}
